import URLConfig from '@Config/urls/url.config';
import { LinkItemProps } from '@Layouts/sidebar/AppSidebar';

const URL = URLConfig.INTERFACE_MANAGEMENT.GIMAC.EMITTER_MENU;

const EmitterMenuLink: Array<LinkItemProps> = [
  {
    name: "Avis d'Emission de Transaction",
    link: URL.TRANSACTION_NOTICE,
    level: 3,
  },
  {
    name: "Saisie d'un ChargeBack",
    link: URL.ENTER_A_CHARGEBACK,
    level: 3,
  },
  {
    name: "Annulation d'un ChargeBack",
    link: URL.CHARGEBACK_CANCELLATION,
    level: 3,
  },
  {
    name: "Consultation des ChargeBack",
    link: URL.CONSULTING_OF_CHARGEBACK,
    level: 3,
  },
  {
    name: "Consultation des Annulations ChargeBack",
    link: URL.CONSULTING_OF_CHARGEBACK_CANCELLATIONS,
    level: 3,
  },
];

export default EmitterMenuLink;
